const initialState = {
  data: [],
  loading: false
}

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'NOTIFICATIONS_FETCH_REQUESTED':
      return { ...state, loading: true }

    case 'NOTIFICATIONS_FETCH_SUCCEEDED':
      return { ...state, loading: false, data: action.response }

    case 'NOTIFICATIONS_FETCH_FAILED':
      return initialState

    default:
      return state
  }
}

export default notificationsReducer
